import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import s from './selections.module.css';

const empty = true;

const ItemsContainer = ({ bgColor }) => {

  /* or maybe show completely different component(with message) when no items instead of empty and trash can */
  // or striked-through trash can if empty
  return (
    <div className={s.itemsContainer} style={{ backgroundImage: `linear-gradient(to bottom, white 0%, ${bgColor} 175%)` }}>
      {(empty) ? <div className={s.rectangle} /> : <div>test</div> }
      <div className='text-right'>
        <FontAwesomeIcon icon={['far', 'trash-alt']} color='#404040' size='lg' className={s.trashIcon} />
      </div>
    </div>
  );

};

export default ItemsContainer;
